import { parsePath } from 'react-router';
import { useStableCallback } from '@arc/frontend/util-common';
import { useDispatchNavAction } from '../nav-action';
/**
 * An improved version of useNavigate.
 *
 * @deprecated Use `useDispatchNavAction` instead.
 */
export function useBetterNavigate(hookOptions) {
  const dispatchNavAction = useDispatchNavAction();
  return useStableCallback((to, callbackOptions) => {
    dispatchNavAction(location => {
      const stringOrPath = typeof to === 'function' ? to(location) : to;

      // Parse the path so that we always work with the separated path components.
      const path = typeof stringOrPath === 'string' ? parsePath(stringOrPath) : stringOrPath;
      const options = {
        ...hookOptions,
        ...callbackOptions,
        ...path
      };
      if (options.merge) {
        return {
          pathname: path.pathname ?? location.pathname,
          search: path.search ?? location.search,
          hash: path.hash ?? location.hash,
          // State can be set to null so we must not use the ?? operator.
          state: options.state === undefined ? location.state : options.state,
          replace: options.replace
        };
      } else {
        return {
          ...path,
          state: options.state,
          replace: options.replace
        };
      }
    });
  });
}